<template>
  <div class="container-fluid py-5">
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
      <img
        class="d-lg-block mb-5 pb-5"
        src="https://ecdassets.s3-us-gov-east-1.amazonaws.com/img/logo.svg"
        width="400"
        alt="eCourtDate logo"
        style="max-width: 100%"
      >
      <div class="row">
        <div class="col-8 offset-2 text-center">
          <h2>Not Found</h2>
          <p class="mt-3">
            Woops! Looks like the page you requested cannot be found.
          </p>
          <router-link
            to="/"
            class="link-hover"
          >
            <h6 class="card-title text-capitalize">
              Go to Dashboard >
            </h6>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>